module.exports = __webpack_public_path__ + "img/happy.e741d519.gif";